import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {AtsRecordsApiModel} from "./ats-records.api-model";
import {AtsRecordsRowDomainModel} from "./row/ats-records.row.domain-model";
import {AtsRecordsRowApiModel} from "./row/ats-records.row.api-model";
import {AtsRecordsColumnDomainModel} from "./column/ats-records.column.domain-model";
import {AtsRecordsColumnApiModel} from "./column/ats-records.column.api-model";

export class AtsRecordsDomainModel extends BaseDomainModel {
  apiModel: AtsRecordsApiModel;

  get title(): String {
    return this.apiModel.title;
  }

  get rows(): Array<AtsRecordsRowDomainModel> {
    return this.apiModel.rows?.map((row: AtsRecordsRowApiModel) => new AtsRecordsRowDomainModel(row));
  }

  get columns(): Array<AtsRecordsColumnDomainModel> {
    return this.apiModel.columns?.map((column: AtsRecordsColumnApiModel) => new AtsRecordsColumnDomainModel(column));
  }
}
